<!-- mapout item summaries -->
 <ul *ngIf="ebayBrowseItems">
 <li *ngFor="let item of ebayBrowseItems.itemSummaries">
    <mat-card class="card-container">
        <mat-card-header>
            <mat-card-title>{{item.title}}</mat-card-title>
            <mat-card-subtitle>Source: Ebay</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="ebay-info-container">
            
                <c-carousel [animate]="false" transition="crossfade" class="carousel-view">
                <c-carousel-indicators></c-carousel-indicators>
                <c-carousel-inner>
                    <c-carousel-item *ngFor="let image of item.additionalImages">
                        <img [src]="image.imageUrl" alt="some image" loading="lazy" class="d-block w-100">
                    </c-carousel-item>

                </c-carousel-inner>
                <c-carousel-control caption="Previous" direction="prev"></c-carousel-control>
                <c-carousel-control caption="Next" direction="next"></c-carousel-control>
            </c-carousel>
                
            
            
            
            <h3>Pricing</h3>
        <div>
            <p>Discounted: 
                {{ item?.marketingPrice?.discountAmount?.value 
                  ? item?.marketingPrice?.discountAmount?.value + ' ' + item?.marketingPrice?.discountAmount?.currency 
                  : 'No discount available' }}
              </p>
              
              <p>Original: 
                {{ item?.marketingPrice?.originalPrice?.value 
                  ? item?.marketingPrice?.originalPrice?.value + ' ' + item?.marketingPrice?.originalPrice?.currency 
                  : 'No price available' }}
              </p>
              <p>Price: 
                {{ item?.price?.value 
                  ? item?.price?.value + ' ' + item?.price?.currency 
                  : 'No price available' }}
              </p>
              
        </div>
            
        </mat-card-content>
        <mat-card-actions class="ebay-info-container">
            <mat-chip-listbox>
                <mat-chip *ngFor="let category of item.categories">{{ category.categoryName }}</mat-chip>
            </mat-chip-listbox>
        </mat-card-actions>
    </mat-card>

 </li>
 </ul>
